import React from 'react';
import styles from "./MainCabinetPage.module.css";
import {Administrator} from "../../../services/models/administrator";
import {isMinzdravUser, isRoivUser, SubUser} from "../../../services/models/sub_user";
import {EventsWrapper} from "../../../components/Events";
import {MapFilter} from "../../../components/MapFilter";


interface MainCabinetPageProps {
    loggedInUser: Administrator | SubUser | null
}

function isAdministrator(obj: any): obj is Administrator {
    return obj && obj.role === undefined
}

const MainCabinetPage: React.FC<MainCabinetPageProps> = ({loggedInUser}) => {
    return (
        <div className={styles.wrapper}>
            <MapFilter isAdministrator={isAdministrator(loggedInUser)} user={loggedInUser} />
            {!isMinzdravUser(loggedInUser as SubUser) && (
                <EventsWrapper isAdministrator={isAdministrator(loggedInUser)}/>
            )}
        </div>
    );
};

export default MainCabinetPage;
